export const GET_DESTINATIONS_TOURS = 'GET_DESTINATIONS_TOURS';
export const GET_POPULAR = 'GET_POPULAR';
export const GET_TOP_CITY = 'GET_TOP_CITY';
export const GET_TOP_ATTRACTIONS = 'GET_TOP_ATTRACTIONS';
export const GET_TOP_COUNTRIES = 'GET_TOP_COUNTRIES';
